<template>
    <div>
        <div class="content-header">
            <div class="container">
                <h1 class="m-0 text-dark">{{ title }}</h1>
            </div>
        </div>
        <form role="form" id="form" v-on:submit.prevent="SubmitForm">
            <div
                class="content"
                v-for="(row1, key1) in config"
                v-bind:key="key1"
            >
                <div class="container container-height">
                    <div class="row">
                        <div
                            v-for="(row2, key2) in row1"
                            v-bind:key="key2"
                            :class="
                                'col-sm-' +
                                (typeof row2.col != 'undefined'
                                    ? row2.col
                                    : '12')
                            "
                        >
                            <div class="card" v-if="if_by(row2, key2)">
                                <div
                                    v-if="typeof row2.title != 'undefined'"
                                    class="card-header"
                                >
                                    <h3 class="card-title">{{ row2.title }}</h3>
                                </div>
                                <div class="card-body options">
                                    <div class="row">
                                        <div
                                            v-for="(row3, key3) in row2.attrs"
                                            v-bind:key="key3"
                                            :class="
                                                'container-height-body col-md-' +
                                                (typeof row3.cols != 'undefined'
                                                    ? row3.cols
                                                    : '12')
                                            "
                                        >
                                            <div
                                                :class="
                                                    row3.type == 'title'
                                                        ? ''
                                                        : 'form-group'
                                                "
                                                v-if="
                                                    typeof row3.show_by ==
                                                        'undefined' ||
                                                    value[row3.show_by] ==
                                                        row3.show_by_value
                                                "
                                            >
                                                <div
                                                    v-for="(row4, key4) in row3"
                                                    v-bind:key="key4"
                                                    :class="
                                                        'col-md-' +
                                                        (typeof row4.cols !=
                                                        'undefined'
                                                            ? row4.cols
                                                            : '12')
                                                    "
                                                    :style="
                                                        'float:left;' +
                                                        ' ' +
                                                        (row4.type == 'hidden'
                                                            ? 'display:none'
                                                            : '')
                                                    "
                                                >
                                                    <label
                                                        :for="key4"
                                                        v-if="
                                                            row4.type !=
                                                                'checkbox' &&
                                                            row4.type !=
                                                                'hidden'
                                                        "
                                                        >{{
                                                            row4.pretty_name
                                                        }}</label
                                                    >

                                                    <input
                                                        v-if="
                                                            row4.type == 'text'
                                                        "
                                                        :id="key4"
                                                        v-model="
                                                            value[row4.name]
                                                        "
                                                        :name="row4.name"
                                                        class="form-control"
                                                        type="text"
                                                        @input="edit++"
                                                        v-bind="normalizeExtra(row4.extra)"
                                                    />

                                                    <input
                                                        v-if="
                                                            row4.type == 'date'
                                                        "
                                                        :id="key4"
                                                        v-model="
                                                            value[row4.name]
                                                        "
                                                        :name="row4.name"
                                                        class="form-control"
                                                        type="date"
                                                        v-bind="normalizeExtra(row4.extra)"
                                                        @input="edit++"
                                                        :placeholder="
                                                            row4.placeholder
                                                        "
                                                    />
                                                    <input
                                                        v-if="
                                                            row4.type == 'time'
                                                        "
                                                        :id="key4"
                                                        v-model="
                                                            value[row4.name]
                                                        "
                                                        :name="row4.name"
                                                        class="form-control"
                                                        type="time"
                                                        v-bind="normalizeExtra(row4.extra)"
                                                        @input="edit++"
                                                        :placeholder="
                                                            row4.placeholder
                                                        "
                                                    />

                                                    <input
                                                        v-if="
                                                            row4.type ==
                                                            'number'
                                                        "
                                                        :id="key4"
                                                        v-model="
                                                            value[row4.name]
                                                        "
                                                        class="form-control"
                                                        type="number"
                                                        @input="edit++"
                                                        :name="row4.name"
                                                        v-bind="normalizeExtra(row4.extra)"
                                                    />
                                                    <input
                                                        v-if="
                                                            row4.type ==
                                                            'hidden'
                                                        "
                                                        :id="key4"
                                                        :name="row4.name"
                                                        v-model="row4.value"
                                                        class="form-control hiddenValue"
                                                        type="hidden"
                                                        v-bind="normalizeExtra(row4.extra)"
                                                    />

                                                    <v-select
                                                        :name="row4.name"
                                                        v-else-if="
                                                            row4.type ==
                                                            'select'
                                                        "
                                                        v-model="
                                                            value[row4.name]
                                                        "
                                                        v-bind="normalizeExtra(row4.extra)"
                                                        @input="edit++"
                                                        @search="
                                                            (search, loading) =>
                                                                onSearch(
                                                                    search,
                                                                    loading,
                                                                    row4,
                                                                    row4.name
                                                                )
                                                        "
                                                        :options="row4.options"
                                                        :id="key4"
                                                        :create-option="
                                                            (value) => ({
                                                                label: value,
                                                                code: value,
                                                            })
                                                        "
                                                        :reduce="
                                                            (value) =>
                                                                value.code
                                                        "
                                                    >
                                                    </v-select>

                                                    <div
                                                        v-else-if="
                                                            row4.type == 'html'
                                                        "
                                                    >
                                                        <vue-editor
                                                            v-model="
                                                                value[row4.name]
                                                            "
                                                        >
                                                        </vue-editor>
                                                        <textarea
                                                            :name="row4.name"
                                                            hidden
                                                            v-model="
                                                                value[row4.name]
                                                            "
                                                            :id="key4"
                                                            cols="30"
                                                            rows="10"
                                                            v-bind="normalizeExtra(row4.extra)"
                                                        >
                                                        </textarea>
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            row4.type ==
                                                            'textarea'
                                                        "
                                                    >
                                                        <textarea
                                                            :name="row4.name"
                                                            v-model="
                                                                value[row4.name]
                                                            "
                                                            :id="key4"
                                                            cols="30"
                                                            rows="10"
                                                            class="form-control"
                                                            v-bind="normalizeExtra(row4.extra)"
                                                        >
                                                        </textarea>
                                                    </div>

                                                    <div
                                                        v-else-if="
                                                            row4.type ==
                                                            'imagen'
                                                        "
                                                    >
                                                        <img
                                                            :id="
                                                                'key_' +
                                                                key4 +
                                                                '_' +
                                                                key2 +
                                                                '_img'
                                                            "
                                                            :src="
                                                                value[row4.name]
                                                                    ? value[
                                                                          row4
                                                                              .name
                                                                      ]
                                                                    : '/img/image-default.webp'
                                                            "
                                                            v-on:click.prevent="
                                                                ClickImagen(
                                                                    'key_' +
                                                                        key4 +
                                                                        '_' +
                                                                        key2
                                                                )
                                                            "
                                                            style="
                                                                cursor: pointer;
                                                                max-width: 100%;
                                                            "
                                                        />
                                                        <input
                                                            :name="row4.name"
                                                            v-bind="normalizeExtra(row4.extra)"
                                                            type="file"
                                                            :id="
                                                                'key_' +
                                                                key4 +
                                                                '_' +
                                                                key2
                                                            "
                                                            :ref="key4"
                                                            @change="
                                                                (event) =>
                                                                    ImagenDestacada(
                                                                        event,
                                                                        value,
                                                                        row4.name,
                                                                        'key_' +
                                                                            key4 +
                                                                            '_' +
                                                                            key2 +
                                                                            '_img'
                                                                    )
                                                            "
                                                            style="
                                                                display: none;
                                                            "
                                                        />
                                                    </div>

                                                    <div
                                                        v-else-if="
                                                            row4.type == 'file'
                                                        "
                                                        style="width: 100%"
                                                    >
                                                        <div
                                                            class="file-types-div"
                                                            v-for="(
                                                                file, keyFile
                                                            ) in valueTMP[
                                                                row4.name
                                                            ]"
                                                            v-bind:key="keyFile"
                                                        >
                                                            <img
                                                                :id="
                                                                    'key_' +
                                                                    key4 +
                                                                    '_' +
                                                                    key2 +
                                                                    '_file'
                                                                "
                                                                :src="'/img/book.png'"
                                                                :title="
                                                                    file.name
                                                                "
                                                                class="file-types-image"
                                                            />
                                                            <span
                                                                :id="
                                                                    'key_' +
                                                                    key4 +
                                                                    '_' +
                                                                    key2 +
                                                                    '_' +
                                                                    key2 +
                                                                    '_file_span'
                                                                "
                                                                class="file-types-text"
                                                                >{{
                                                                    file.type
                                                                }}</span
                                                            >
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-danger file-types-trash"
                                                                @click="
                                                                    (event) =>
                                                                        FileDelete(
                                                                            row4,
                                                                            row4.name,
                                                                            keyFile
                                                                        )
                                                                "
                                                            >
                                                                <i
                                                                    class="fa fa-times"
                                                                ></i>
                                                            </button>
                                                            <button
                                                                v-if="
                                                                    typeof file.id ==
                                                                    'number'
                                                                "
                                                                type="button"
                                                                class="btn btn-sm btn-success file-types-check"
                                                            >
                                                                <i
                                                                    class="fa fa-check"
                                                                ></i>
                                                            </button>
                                                        </div>
                                                        <div
                                                            class="file-types-div"
                                                        >
                                                            <img
                                                                :id="
                                                                    'key_' +
                                                                    key4 +
                                                                    '_' +
                                                                    key2 +
                                                                    '_file'
                                                                "
                                                                :src="'/img/book-plus.png'"
                                                                v-on:click.prevent="
                                                                    ClickImagen(
                                                                        'key_' +
                                                                            key4 +
                                                                            '_' +
                                                                            key2
                                                                    )
                                                                "
                                                                class="file-types-image"
                                                            />
                                                            <span
                                                                :id="
                                                                    'key_' +
                                                                    key4 +
                                                                    '_' +
                                                                    key2 +
                                                                    '_file_span'
                                                                "
                                                                class="file-types-text"
                                                            ></span>
                                                            <input
                                                                :name="
                                                                    row4.name
                                                                "
                                                                type="file"
                                                                v-bind="normalizeExtra(row4.extra)"
                                                                :id="
                                                                    'key_' +
                                                                    key4 +
                                                                    '_' +
                                                                    key2
                                                                "
                                                                :ref="key4"
                                                                @change="
                                                                    (event) =>
                                                                        FileChange(
                                                                            event,
                                                                            value,
                                                                            row4.name,
                                                                            'key_' +
                                                                                key4 +
                                                                                '_' +
                                                                                key2,
                                                                            row4.name
                                                                        )
                                                                "
                                                                style="
                                                                    display: none;
                                                                "
                                                            />
                                                        </div>
                                                    </div>

                                                    <div
                                                        v-else-if="
                                                            row4.type ==
                                                            'checkbox'
                                                        "
                                                        class="form-check"
                                                    >
                                                        <input
                                                            :name="row4.name"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            :id="row4.name"
                                                            v-model="
                                                                value[row4.name]
                                                            "
                                                            v-bind="normalizeExtra(row4.extra)"
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            :for="row4.name"
                                                        >
                                                            {{
                                                                row4.pretty_name
                                                            }}
                                                        </label>
                                                    </div>

                                                    <br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="card-footer"
                                    v-if="typeof row2.footer != 'undefined'"
                                >
                                    <div
                                        v-if="
                                            typeof row2.footer.buttons !=
                                            'undefined'
                                        "
                                        class="row"
                                    >
                                        <div class="col-md-12">
                                            <button
                                                v-for="(button, keyb) in row2
                                                    .footer.buttons"
                                                v-bind:key="keyb"
                                                :type="button.type"
                                                :class="button.class"
                                                v-on:click.prevent="
                                                    typeof button.route !=
                                                        'undefined' &&
                                                    button.type != 'submit'
                                                        ? RedirectButton(
                                                              button.route
                                                          )
                                                        : SubmitForm()
                                                "
                                            >
                                                {{ button.text }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- {{ value }} -->
            <input type="hidden" v-model="edit" />
        </form>
        <!-- {{ form }} -->
    </div>
</template>
<style>
.container-height {
    display: table;
}

.options {
    display: table-row;
}

.container-height-body {
    display: table-cell;
}

.unselectable {
    display: table-cell;
}
</style>
<script type="text/javascript">
export default {
    props: [
        "watch",
        "form",
        "title",
        "footer",
        "submit_url",
        "submit_in_url",
        "redirect_submit_url",
        "redirect_submit_url_params",
        "edit_get_url",
    ],
    data() {
        return {
            config: {},
            value: {},
            valueTMP: {},
            edit: 0,
        };
    },
    computed: {},
    methods: {
        if_by(row1, key1) {
            if (!row1.if_by) {
                return true;
            }

            if (
                row1.if_by?.key &&
                this.value[row1.if_by.key] === row1.if_by.is
            ) {
                return true;
            }

            return false;
        },
            normalizeExtra(extra) {
                if (!extra) {
                    return {};
                }

                if (Array.isArray(extra)) {
                    return Object.assign(
                        {},
                        ...extra.filter(
                            (item) => item && typeof item === "object"
                        )
                    );
                }

                if (typeof extra === "object") {
                    const merged = Object.assign({}, extra);
                    Object.keys(merged).forEach((k) => {
                        if (/^\d+$/.test(k)) {
                            delete merged[k];
                        }
                    });
                    return merged;
                }

                return {};
            },
        async SubmitForm() {
            let value = Object.keys(this.value);
            let request = {};
            for (let index = 0; index < value.length; index++) {
                let index2 = value[index];
                let splitResult = value[index].split(".");

                if (splitResult.length == 2) {
                    if (typeof request[splitResult[0]] == "undefined") {
                        request[splitResult[0]] = {};
                        request[splitResult[0]][splitResult[1]] =
                            this.value[index2];
                    } else {
                        request[splitResult[0]][splitResult[1]] =
                            this.value[index2];
                    }
                } else {
                    request[splitResult[0]] = this.value[index2];
                }
            }
            Object.keys(request).forEach((key) => {
                if (request[key] === undefined) {
                    delete request[key];
                }
            });
            let form = new FormData();

            for (let key in request) {
                if (typeof request[key] == "object") {
                    for (let key2 in request[key]) {
                        form.append(key + "[" + key2 + "]", request[key][key2]);
                    }
                } else {
                    form.append(key, request[key]);
                }
            }

            let hiddens = $(".hiddenValue");
            for (let index = 0; index < hiddens.length; index++) {
                if (form.get(hiddens[index].name) === null) {
                    form.append(hiddens[index].name, hiddens[index].value);
                }
            }

            //   return;
            if (this.submit_in_url) {
                let params = new URLSearchParams(form);
                let href = this.submit_url + "?" + params;
                this.$router.push(href);
            } else {
                this.$root
                    .Consulta(
                        this.submit_url,
                        form,
                        "post",
                        false,
                        true,
                        ".card-body",
                        "initial"
                    )
                    .then((response) => {
                        if (response != false && this.redirect_submit_url) {
                            const params =
                                this.redirect_submit_url_params ?? {};
                            this.$router.push({
                                name: this.redirect_submit_url,
                                params: params,
                            });
                        }
                    });
            }
        },
        ClickImagen(key) {
            $("#" + key).click();
        },
        FileChange: function (event, image, key, keyFIle, valueName) {
            let input = event.target;

            if (input.files && input.files[0]) {
                let n = this;
                let cont = 0;
                let newTemp = [];
                let newVal = [];

                for (let index in n.valueTMP[valueName]) {
                    if (typeof n.valueTMP[valueName][index].id == "number") {
                        newTemp[cont] = n.valueTMP[valueName][index];
                        newVal[cont] = n.valueTMP[valueName][index].id;
                        cont++;
                    }
                }

                n.valueTMP[valueName] = newTemp;
                n.value[valueName] = newVal;

                for (let index = 0; index < input.files.length; index++) {
                    let name = input.files[index].name;
                    let type = name.match(/\.[0-9a-z]+$/i);

                    n.valueTMP[valueName].push({
                        name: name,
                        type: type[0],
                    });

                    n.value[valueName][cont] = input.files[index];
                    cont++;
                }
                n.edit++;
            }
        },
        FileDelete: function (row, name, key) {
            if (typeof this.valueTMP[name][key].id != "undefined") {
                this.$swal
                    .fire({
                        title: "Eliminar Archivo?",
                        text: "Este archivo ya se encuentra registrado, de eliminarlo se perdera todo rastro de el, recuerde guardar para que surja efecto!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Si!",
                        cancelButtonText: "Cancelar",
                    })
                    .then((result) => {
                        if (!result.isDenied && !result.isDismissed) {
                            this.FileDeleteConfirm(row, name, key);
                        }
                    });
            } else {
                this.FileDeleteConfirm(row, name, key);
            }
        },
        FileDeleteConfirm(row, name, key) {
            let newArray = [];

            for (let index = 0; index < this.value[name].length; index++) {
                if (
                    this.value[name][index].name !=
                        this.valueTMP[name][key].name &&
                    this.value[name][index] != this.valueTMP[name][key].id
                ) {
                    newArray.push(this.value[name][index]);
                }
            }

            this.valueTMP[name].splice(key, 1);
            this.value[name] = newArray;

            this.edit++;
        },
        ImagenDestacada: function (event, image, key, keyimg) {
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                let n = this;
                reader.onload = function (e) {
                    $("#" + event.target.id).attr("src", e.target.result);
                    $("#" + keyimg).attr("src", e.target.result);
                    n.value[key] = e.target.result;
                    image[key] = e.target.result;
                };
                reader.readAsDataURL(input.files[0]); // convert to base64 string
            }
        },
        inicializar(model) {
            switch (model.type) {
                case "select":
                    if (typeof this.value[model.name] == "undefined") {
                        let split = model.name.split(".");
                        if (
                            split.length == 2 &&
                            typeof this.value[split[0]] != "undefined" &&
                            typeof this.value[split[0]][split[1]] != "undefined"
                        ) {
                            this.value[split[0] + "." + split[1]] =
                                this.value[split[0]][split[1]];
                        }
                    }

                    if (
                        typeof model.ajax == "object" &&
                        typeof this.value[model.name] != "undefined" &&
                        typeof model.extra != "undefined" &&
                        typeof model.extra.multiple != "undefined" &&
                        model.extra.multiple == true
                    ) {
                        let options2 = JSON.parse(
                            JSON.stringify(this.value[model.name])
                        );
                        this.value[model.name] = [];
                        for (let index in options2) {
                            this.value[model.name][index] =
                                options2[index].code;
                        }
                    } else if (
                        typeof model.ajax == "object" &&
                        typeof this.value[model.name] != "undefined"
                    ) {
                        let option2 = this.value[model.name];
                        model.options = JSON.parse(
                            JSON.stringify(this.value[model.name])
                        );
                        this.value[model.name] = option2[0].code;
                    }
                    this.edit++;

                    break;
                case "file":
                    if (
                        typeof this.valueTMP[model.name] == "undefined" &&
                        typeof this.value[model.name] != "undefined"
                    ) {
                        this.valueTMP[model.name] = this.value[model.name];
                        let newArray = [];
                        let cont = 0;
                        for (let index in this.value[model.name]) {
                            newArray[index] = this.value[model.name][index].id;
                        }
                        this.value[model.name] = newArray;
                    }
                    break;
                case "hidden":
                case "number":
                case "text":
                case "date":
                    if (typeof this.value[model.name] == "undefined") {
                        let split = model.name.split(".");
                        if (
                            split.length == 2 &&
                            typeof this.value[split[0]] != "undefined" &&
                            typeof this.value[split[0]][split[1]] != "undefined"
                        ) {
                            this.value[split[0] + "." + split[1]] =
                                this.value[split[0]][split[1]];
                        }
                    }
                    break;

                default:
                    break;
            }
            this.edit++;
        },
        RedirectButton: function (route) {
            this.$router.push({ name: route });
        },
        onSearch(search, loading, option, odefault) {
            if (
                typeof option.options[0] == "undefined" ||
                typeof option.options[0].search == "undefined" ||
                option.options[0].search != false
            ) {
                if (
                    typeof this.value[option.name] != "undefined" &&
                    typeof this.value[option.name][0] == "object"
                ) {
                    option.options = this.value[odefault];
                    this.value[odefault] = [];
                    for (let index in option.options) {
                        this.value[odefault][index] =
                            option.options[index].code;
                    }
                }

                if (typeof option.ajax != "undefined" && search.length) {
                    loading(true);
                    let url = option.ajax.url + "?q=" + escape(search);
                    this.search(loading, search, option, url, this);
                }
            }
        },
        search: _.debounce((loading, search, option, url, n) => {
            let data = {
                label: option.ajax.label,
                code: option.ajax.code,
                filtro: {},
            };

            data["filtro"][option.ajax.filter] = search;

            n.$root
                .Consulta(url, data, "post", false, false, false, "", false)
                .then((response) => {
                    let newValues = [];

                    if (typeof n.value[option.name] != "undefined") {
                        let cont = 0;
                        for (let temp in n.value[option.name]) {
                            let temp2 = option.options.find(
                                (element) =>
                                    element.code == n.value[option.name][temp]
                            );
                            if (
                                typeof temp2 != "undefined" &&
                                typeof temp2.code != "undefined" &&
                                typeof response.find(
                                    (element) => element.code == temp2.code
                                ) == "undefined" &&
                                Number.isInteger(temp2.code)
                            ) {
                                newValues[cont] = temp2;
                                cont++;
                            }
                        }
                    }
                    option.options = response.concat(newValues);
                    loading(false);
                });
        }, 350),
    },
    mounted() {},
    created() {
        this.config = this.form;
        let this2 = this;

        if (typeof this.watch != "undefined") {
            for (let index in this.watch) {
                this.$watch(this.watch[index].watch, (newVal, oldVal) => {
                    let type =
                        typeof this.watch[index].type != "undefined"
                            ? this.watch[index].type
                            : "default";
                    let data;
                    let dataD;
                    switch (type) {
                        case "disable":
                            dataD = { attributes: this.watch[index].attr };
                            dataD.value = newVal;
                            // console.log(dataD)
                            this.$root
                                .Consulta(
                                    this.watch[index].route,
                                    dataD,
                                    "post",
                                    false,
                                    false,
                                    false,
                                    "",
                                    false
                                )
                                .then((response) => {
                                    let indices = this.watch[index].select;
                                    this.config[indices[0]][indices[1]].attrs[
                                        indices[2]
                                    ][indices[3]].extra = {
                                        disabled:
                                            response[this.watch[index].model],
                                    };
                                    // console.log(this.config[indices[0]][indices[1]].attrs[indices[2]][indices[3]]);
                                });
                            break;

                        case "section":
                            data = { codigo: newVal };

                            this.$root
                                .Consulta(
                                    this.watch[index].route,
                                    data,
                                    "post",
                                    false,
                                    false,
                                    false,
                                    "",
                                    false
                                )
                                .then((response) => {
                                    console.log(response);
                                });
                            break;

                        default:
                            data = { selects: {} };

                            data["selects"][this.watch[index].model] = {};
                            data["selects"][this.watch[index].model]["extra"] =
                                this.watch[index].extra;
                            data["selects"][this.watch[index].model]["model"] =
                                this.watch[index].model;
                            data["selects"][this.watch[index].model]["code"] =
                                this.watch[index].code;
                            data["selects"][this.watch[index].model]["label"] =
                                this.watch[index].label;
                            data["selects"][this.watch[index].model]["where"] =
                                {};

                            data["selects"][this.watch[index].model]["where"][
                                this.watch[index].attr
                            ] = newVal;

                            if (this.watch[index].where) {
                                data["selects"][this.watch[index].model][
                                    "where"
                                ] = Object.assign(
                                    {},
                                    data["selects"][this.watch[index].model][
                                        "where"
                                    ],
                                    JSON.parse(
                                        JSON.stringify(this.watch[index].where)
                                    )
                                );
                            }

                            data["selects"][this.watch[index].model][
                                this.watch[index].attr
                            ] = newVal;

                            this.$root
                                .Consulta(
                                    this.watch[index].route,
                                    data,
                                    "post",
                                    false,
                                    false,
                                    false,
                                    "",
                                    false
                                )
                                .then((response) => {
                                    let indices = this.watch[index].select;
                                    if (this.watch[index].select === false) {
                                    } else {
                                        this.config[indices[0]][
                                            indices[1]
                                        ].attrs[indices[2]][
                                            indices[3]
                                        ].options =
                                            response[this.watch[index].model];
                                    }
                                });
                            break;
                    }
                });
            }
        }

        if (typeof this.$route.params.id != "undefined") {
            this.$root
                .Consulta(
                    this.edit_get_url,
                    this.value,
                    "post",
                    false,
                    false,
                    ".card-body",
                    "initial"
                )
                .then((response) => {
                    this.value = response;
                    for (let key1 in this.config) {
                        for (let key2 in this.config[key1]) {
                            for (let key3 in this.config[key1][key2].attrs) {
                                this.inicializar(
                                    this.config[key1][key2].attrs[key3]
                                );
                                this2.edit++;
                            }
                        }
                    }
                    this.edit++;
                });
            this.edit++;
        }

        for (var key in this.config) {
            for (var key2 in this.config[key]) {
                for (var key3 in this.config[key][key2].attrs) {
                    for (var key4 in this.config[key][key2].attrs[key3]) {
                        if (
                            this.config[key][key2].attrs[key3][key4].value !==
                            ""
                        ) {
                            this.value[
                                this.config[key][key2].attrs[key3][key4].name
                            ] = this.config[key][key2].attrs[key3][key4].value;
                        }
                    }
                }
            }
        }
    },
    watch: {
        value(val) {
            this.$emit("input", val);
        },
    },
};
</script>
